import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import './lib/i18n'

const container = document.getElementById('root')
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// Register assets service worker for offline asset support
if ('serviceWorker' in navigator) {
  // console.log('Service Worker: Browser supports service workers')

  // Only register on RBL subdomain
  const isRBLDomain = window.location.hostname === 'rbl.joinmytalent.com' ||
                     window.location.hostname === 'localhost' ||
                     window.location.hostname.includes('localhost')

  if (!isRBLDomain) {
    console.log('Service Worker: Not registering - not on RBL domain:', window.location.hostname)
  } else {
    console.log('Service Worker: On RBL domain, proceeding with registration')

    ;(async () => {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations()
        // console.log(`Service Worker: Found ${registrations.length} existing registrations`)

        for (const registration of registrations) {
          // console.log('Service Worker: Unregistering old service worker:', registration.scope)
          await registration.unregister()
        }

        // Small delay after unregistering
        await new Promise(resolve => setTimeout(resolve, 500))

        // console.log('Service Worker: Registering assets service worker...')
        const registration = await navigator.serviceWorker.register('/assets-service-worker.js', {
          scope: '/'
        })

        console.log('Service Worker: Registration successful', {
          scope: registration.scope,
          active: !!registration.active,
          waiting: !!registration.waiting,
          installing: !!registration.installing
        })

        // Force immediate activation if installing
        if (registration.installing) {
          // console.log('Service Worker: Sending SKIP_WAITING to installing worker')
          registration.installing.postMessage({ type: 'SKIP_WAITING' })
        }

        // Wait for activation
        await new Promise((resolve) => {
          if (registration.active) {
            // console.log('Service Worker: Already active')
            resolve(undefined)
            return
          }

          const checkState = () => {
            if (registration.active) {
              // console.log('Service Worker: Now active')
              resolve(undefined)
            } else {
              setTimeout(checkState, 100)
            }
          }
          checkState()
        })

        // Verify it's working by checking if it intercepts a known asset request
        // console.log('Service Worker: Testing asset interception...')
        // const testResponse = await fetch('/assets/icon/logo.svg', { cache: 'no-cache' })
        // console.log('Service Worker: Test fetch response:', testResponse.status)
      } catch (error) {
        console.error('Service Worker: Registration failed:', error)
      }
    })()
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
